const isQuestionnaireItemValid = (item, answers) => {
  if (item.questionnaireItemType === 'SectionHeader' || !item.isRequired) {
    return true;
  }
  const answer = answers.find((a) => a.questionnaireItemId === item.questionnaireItemId);
  if (answer === undefined) {
    return false;
  }
  if (item.questionnaireItemType === 'SingleSelectionDropdownQuestion' ||
      item.questionnaireItemType === 'SingleSelectionRadioButtonQuestion' ||
      item.questionnaireItemType === 'BooleanQuestion' ||
      item.questionnaireItemType === 'QuestionMatrixGrouping') {
    const listAnswerItem = item.listAnswers.find((l) => l.listAnswerId === answer.listAnswerId);
    if (listAnswerItem.isOtherOption) {
      return answer.otherOptionText !== '';
    }
    return true;
  }
  if (item.questionnaireItemType === 'TextQuestion') {
    return answer.textAnswer !== '';
  }
  if (item.questionnaireItemType === 'DateQuestion') {
    return answer.dateAnswer !== null;
  }
  if (item.questionnaireItemType === 'NumberQuestion') {
    return answer.numberAnswer !== '';
  }
  if (item.questionnaireItemType === 'MultiSelectionQuestion') {
    let hasInvalidCheckboxAnswer = false;
    const checkboxAnswers =
      answers.filter((a) => a.questionnaireItemId === item.questionnaireItemId);
    checkboxAnswers.map((a) => {
      const listAnswerItem = item.listAnswers.find((l) => l.listAnswerId === a.listAnswerId);
      if (listAnswerItem.isOtherOption) {
        hasInvalidCheckboxAnswer = a.otherOptionText === '';
      }
      return a;
    });
    return !hasInvalidCheckboxAnswer;
  }

  return true;
};

const validateOptionText = (item, answers) => {
  let listAnswers = item.listAnswers;
  if (item.questionnaireItemType === 'MultiSelectionQuestion' ||
      item.questionnaireItemType === 'SingleSelectionRadioButtonQuestion' ||
      item.questionnaireItemType === 'SingleSelectionDropdownQuestion' ||
      item.questionnaireItemType === 'BooleanQuestion') {
    listAnswers = item.listAnswers.map((l) => {
      const answer = answers.find((a) => l.listAnswerId === a.listAnswerId);
      let isOtherTextValid = true;
      if (answer && l.isOtherOption) {
        isOtherTextValid = answer.otherOptionText !== '';
      }
      return { ...l, isOtherTextValid };
    });
  }

  return listAnswers;
};

export const validateQuestionnaire = (questionnaire) => {
  const validatedQuestionnaire = { ...questionnaire,
    questionnaireItems: questionnaire.questionnaireItems.map(
      (item) => {
        const isValid = isQuestionnaireItemValid(item, questionnaire.patientQuestionAnswerList);
        const isOtherTextValid = validateOptionText(item, questionnaire.patientQuestionAnswerList);
        return { ...item, isValid, listAnswers: isOtherTextValid };
      }
    ) };

  return { ...validatedQuestionnaire,
    isValid: validatedQuestionnaire.questionnaireItems.find((i) => i.isValid === false) === undefined };
};
